import BaseModel from '@/libs/base/dataModel/BaseModel';
import { isNumberWithZero, isPhone } from '@/libs/regularUtils';
const MERCHANT_STATUS =
    { 1: '待开户', 2: '开户中', 3: '已开户', 4: '开户失败' };
// 商户管理数据
export class AgentMerchantListModel extends BaseModel {
  constructor () {
    super();
    this.id = ''; // id
    this.accAmt = ''; // 账户可用余额
    this.businessType = ''; // 业态体系
    this.businessTypeName = ''; // 业态体系
    this.freezeAmount = ''; // 实际冻结金额
    // this.frozenAmount = ''; // 实际冻结金额
    this.merchantCode = ''; // 商户code
    this.merchantCompany = ''; // 商户名称
    this.merchantDevice = ''; //
    this.merchantName = ''; // 商户名称
    this.merchantStatus = ''; // 开户状态（1待开户，2开户中，3已开户,4开户失败）
    this.merchantStatusDesc = ''; // 开户状态
    this.merchantStatusName = ''; // 开户状态
    this.merchantTel = ''; // 商户手机号
    this.officeName = ''; // 办事处
    this.relationNum = ''; // 已关联商户
    this.smsFlag = ''; // 短信核验
    this.smsFlagDesc = ''; // 短信核验
    this.totalAmount = ''; // 账户余额
    this.updateBy = ''; // 操作人
    this.updateTime = ''; // 操作时间
    this.updateTimeStr = ''; // 操作时间
    this.warningAmount = ''; // 预警金额
    this.earlyWarningTels = ''; // 预警手机号
  }

  initData (resData) {
    super.initData(resData);
    this.relationNum = resData.relationNum + '';
    this.merchantStatusName = MERCHANT_STATUS[this.merchantStatus + ''];
    return this;
  }

  static createFakeDataList () {
    const list = [];
    const merchantStatusArr = ['待开户', '开户中', '开户成功', '开户失败'];
    const smsCheckStatusArr = ['不可核验', '可核验'];
    for (let i = 0; i < 30; i++) {
      const dic = {
        merchantCompany: BaseModel.getFakeTitle(8),
        merchantCode: '0000' + i,
        merchantTel: '1' + BaseModel.getFakeNumber(9999999999, 0),
        officeName: BaseModel.getFakeTitle(8),
        merchantStatus: i % 4,
        merchantStatusDesc: merchantStatusArr[i % 4],
        smsFlag: i % 2,
        smsFlagDesc: smsCheckStatusArr[i % 2],
        relationNum: BaseModel.getFakeNumber(9, 0),
        accAmt: BaseModel.getFakeNumber(9999),
        freezeAmount: BaseModel.getFakeNumber(9999),
        // FrozenAmount: BaseModel.getFakeNumber(9999),
        warningAmount: BaseModel.getFakeNumber(9999),
        earlyWarningTels: '153875478' + BaseModel.getFakeNumber(9999),
        totalAmount: BaseModel.getFakeNumber(9999),
        updateBy: '1' + BaseModel.getFakeNumber(9999999999, 0),
        updateTime: '2025-06-05 16:06:0' + i,
        updateTimeStr: '2025-06-05 16:06:0' + i
      };
      list.push(dic);
    }
    return list;
  }
}

export class AgentMerchantDetailModel extends AgentMerchantListModel {
  constructor () {
    super();
    this.officeCode = ''; // 所属办事处
    this.merchantType = 1; // 商户类型（1.内部个人，2.内部企业，3.外部个人，4.外部企业）
    this.merchantTypeName = ''; // 商户类型（1.个人，2企业）
    this.idCard = ''; // 证件号码
    this.idCardType = 1; // 证件类型（1.身份证，2.营业执照）
    this.idCardTypeName = ''; // 证件类型
    this.accountIn = ''; // 商家编号-富有生成的编号
    this.bankName = ''; // 开户银行
    this.bankNo = ''; // 银行账号
    this.interBankNo = ''; // 开户行行号
    this.branchBank = ''; // 分行
    this.merchantTel = ''; // 商户手机号
    this.freezeAmount = ''; // 冻结金额
    this.withdrawAmt = ''; // 可提现金额
    this.withdrawPending = ''; // 提现待到账
    this.preFrozenAmount = ''; // 预计冻结金额
    // this.frozenAmount = ''; // 冻结金额
    this.transitAmount = ''; // 在途金额
    this.withdrawTotal = ''; // 累计提现
    // 银行信息
    this.merchantBankList = null;
    this.warningAmount = null;
    this.earlyWarningTels = null;
  }

  initData (resData) {
    super.initData(resData);
    this.withdrawAmt = this.withdrawAmt || 0;
    this.withdrawPending = this.withdrawPending || 0;
    this.withdrawTotal = this.withdrawTotal || 0;
    this.accAmt = this.accAmt || 0;
    this.preFrozenAmount = (this.preFrozenAmount + '') || '0';
    // this.frozenAmount = (this.frozenAmount + '') || '0';
    this.warningAmount = (this.warningAmount + '') || '0';
    this.freezeAmount = (this.freezeAmount + '') || '0';
    this.earlyWarningTels = (this.earlyWarningTels + '') || '0';
    if (BaseModel.checkArray(this.merchantBankList) && this.merchantBankList.length) {
      this.merchantBankList.forEach(v => {
        v.h5BankTel = this.merchantTel;
      });
      this.bankName = resData.merchantBankList[0].bankName;
      this.bankNo = resData.merchantBankList[0].bankNo;
      this.interBankNo = resData.merchantBankList[0].interBankNo;
      this.branchBank = resData.merchantBankList[0].branchBank;
    } else {
      this.merchantBankList = [
        {
          branchBank: '',
          bankNo: '',
          h5BankTel: ''
        }
      ];
    }
    return this;
  }

  static createFakeData () {
    const dic = AgentMerchantListModel.createFakeDataList(1);
    return {
      ...dic,
      ...{
        merchantType: '',
        merchantTypeName: '个人',
        idCardType: '',
        idCard: '13300000' + BaseModel.getFakeNumber(1000, 0),
        bankNo: '2900000' + BaseModel.getFakeNumber(1000, 0),
        bankName: BaseModel.getFakeTitle(10),
        branchBank: BaseModel.getFakeTitle(10),
        merchantTel: 13900000000 + BaseModel.getFakeNumber(1000, 0),
        withdrawAmt: 2000,
        withdrawPending: 3000,
        withdrawTotal: 4000,
        accAmt: 1000,
        freezeAmount: 1000,
        // FrozenAmount: 1000,
        warningAmount: 1000,
        earlyWarningTels: '13695285690',
        accountIn: 'FY4008508088000000123',
        merchantBankList: [
          {
            branchBank: '招商银行金沙江路支行',
            bankNo: '4008508088000000'
          }
        ]
      }
    };
  }

  /**
   * 数据具体校验-新增/编辑
   * @returns {*}
   */
  checkSubmitValid () {
    if (!isPhone(this.merchantTel)) {
      return BaseModel.getValidRes(false, '手机号码有误');
    }
    if (!isPhone(this.earlyWarningTels)) {
      return BaseModel.getValidRes(false, '预警手机号码有误');
    }
    //
    // if (!isNumberWithZero(this.preFrozenAmount)) {
    //   return BaseModel.getValidRes(false, '冻结金额仅可填写0及正整数');
    // }
    if (!isNumberWithZero(this.freezeAmount)) {
      return BaseModel.getValidRes(false, '冻结金额仅可填写0及正整数');
    }
    if (!isNumberWithZero(this.warningAmount)) {
      return BaseModel.getValidRes(false, '预警金额仅可填写0及正整数');
    }

    const params = {
      // businessType: this.businessType,
      // idCardType: this.idCardType,
      officeCode: this.officeCode,
      merchantType: this.merchantType,
      idCard: this.idCard,
      merchantCompany: this.merchantCompany,
      merchantName: this.merchantCompany,
      merchantTel: this.merchantTel,
      bankName: this.bankName,
      branchBank: this.branchBank,
      interBankNo: this.interBankNo,
      bankNo: this.bankNo,
      // preFrozenAmount: this.preFrozenAmount
      frozenAmount: this.freezeAmount,
      warningAmount: this.warningAmount,
      earlyWarningTels: this.earlyWarningTels
    };

    if (this.id) { // 编辑
      params.id = this.id;
      params.merchantCode = this.merchantCode;
      params.merchantId = params.id;
    }

    return BaseModel.getValidRes(true, '', params);
  }

  static createAdditionModel () {
    return new this();
  }
}

// 关联商户数据
export class AssociateMerchantListModel extends BaseModel {
  constructor () {
    super();
    this.id = ''; // id
    // this.merchantName = ''; // 商户名称
    // this.merchantCode = ''; // 商户code
    // this.updateBy = ''; // 操作人
    // this.relationTime = ''; // 操作时间
    this.communityName = ''; // 小区名称
    this.communityCode = ''; // 小区code
    this.communityId = ''; // 小区id
    this.operatorName = ''; // 操作人
    this.operatorTime = ''; // 操作时间
  }

  static createFakeDataList () {
    const list = [];
    for (let i = 0; i < 30; i++) {
      const dic = {
        communityName: BaseModel.getFakeTitle(8),
        communityCode: 'KJHKHHJK0000' + i,
        communityId: '95078234' + i,
        operatorName: '13904288032',
        operatorTime: '2025-06-05 10:36:0' + i
      };
      list.push(dic);
    }
    return {
      list,
      total: 50
    };
  }
}
